import React from "react";
import { RecoilRoot } from "recoil";

import { ProxyCheckupNew } from '../uiParts/proxy_checkup/ProxyCheckupNew';
import { ProxyCheckupEdit } from '../uiParts/proxy_checkup/ProxyCheckupEdit';

// Edit用
import { orderState } from '../store/orderState';
import { optionState } from '../store/optionState';
import { courceClinicState } from '../store/courceClinicState';
import { selectedCourceClinicState } from '../store/selectedCourceClinicState';

const ProxyCheckup = (props) => {
  const { 
    cm, user, staff_user, cources, seiken_cources, options, page_title, checkup, cource_clinics, cource_clinic, clinic, cource_items, junkai_cources
  } = props;

  // 編集の場合の初期値のセット
  const initializeState = ({ set }) => {
    set(orderState, checkup);
    set(courceClinicState, cource_clinics);
    set(selectedCourceClinicState, {
      id: cource_clinic.id,
      clinic_id: clinic.id,
      name: clinic.name,
      prefecture_code: clinic.prefecture_code,
      address: clinic.address,
      tel: clinic.tel,
    });
    set(optionState, options);
  };

  console.log("Agent Checkup");
  return (
    <RecoilRoot initializeState={checkup && initializeState}>
      <nav className="mb-3">
        <a href="/agent" className="btn btn-outline-secondary">
          <i className="fas fa-chevron-left"></i> TOPへ戻る
        </a>
      </nav>
      { checkup ?
        <ProxyCheckupEdit
          cm={cm}
          user={user}
          staff_user={staff_user}
          page_title={page_title}
          cources={cources}
          cource_clinics={cource_clinics}
        />
      :
        <ProxyCheckupNew
          cm={cm}
          user={user}
          staff_user={staff_user}
          page_title={page_title}
          cources={cources}
          seiken_cources={seiken_cources}
          junkai_cources={junkai_cources}
        />
      }
    </RecoilRoot>
  );
};

export default ProxyCheckup;
